import { isClient } from '@vueuse/shared'

export const useIsBrowser = () => {
  try {
    if (isClient || import.meta.browser) {
      return true
    }
  } catch (e) {
  }
  return false
}
